import * as React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const CustomFormControlLabel = (props) => {
    return <FormControlLabel {...props} />;
};

export { CustomFormControlLabel as FormControlLabel };
